/** @jsxRuntime classic */
/* @jsx node */
import { Skeleton, SkeletonStyles } from 'app/sdk/components/Skeleton';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { node } from 'jsx-pragmatic';

export const PaymentMethodsZoidSkeleton = () => (
  <html>
    <body>
      <SkeletonStyles />
      <div>
        <div>
          <div style="height: 122px; padding: 72px 35px 35px; margin-bottom: 12px; border-bottom: solid rgba(0, 0, 0, 0.15) 1px;">
            <Skeleton height={16} width="260" style="margin-top: 50px; margin-bottom: 21px;" />
            <div style="display: flex; flex-direction: row; padding: 0px; margin-bottom: 50px; ">
              <Skeleton height={16} width={109} style="margin-right: 8px" />
              <Skeleton height={16} width={30} style="margin-right: 8px" />
              <Skeleton height={16} width={89} style="margin-right: 8px" />
            </div>
          </div>
          <div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 12px">
            <div style="width: 80%; border-radius: 8px; box-shadow: -14px 23px 34px -10px rgb(0 0 0 / 8%), 3px -3px 20px 1px rgb(255 255 255 / 88%); padding: 20px; margin-bottom: 32px; display: flex; justify-content: space-between; align-items: center;">
              <Skeleton style="margin-top: 16px" height={18} width={215} />
              <Skeleton style="margin-top: 16px" height={16} width={51} />
            </div>
            <div style="width: 80%; border-radius: 8px; box-shadow: -14px 23px 34px -10px rgb(0 0 0 / 8%), 3px -3px 20px 1px rgb(255 255 255 / 88%); padding: 20px; margin-bottom: 32px; display: flex; justify-content: space-between; align-items: center;">
              <Skeleton style="margin-top: 16px" height={18} width={215} />
              <Skeleton style="margin-top: 16px" height={16} width={51} />
            </div>
            <div style="width: 80%; border-radius: 8px; box-shadow: -14px 23px 34px -10px rgb(0 0 0 / 8%), 3px -3px 20px 1px rgb(255 255 255 / 88%); padding: 20px; margin-bottom: 32px; display: flex; justify-content: space-between; align-items: center;">
              <Skeleton style="margin-top: 16px" height={18} width={215} />
              <Skeleton style="margin-top: 16px" height={16} width={51} />
            </div>
            <div style="width: 80%; border-radius: 8px; box-shadow: -14px 23px 34px -10px rgb(0 0 0 / 8%), 3px -3px 20px 1px rgb(255 255 255 / 88%); padding: 20px; margin-bottom: 32px; display: flex; justify-content: space-between; align-items: center;">
              <Skeleton style="margin-top: 16px" height={18} width={215} />
              <Skeleton style="margin-top: 16px" height={16} width={51} />
            </div>
            <Skeleton height={12} width={230} style="margin-top: 2px" />
            <Skeleton height={20} width={193} style="margin-top: 2px" />
          </div>
        </div>
      </div>
    </body>
  </html>
);
